<div [ngClass]="{'u-max-height-100-percent': maxHeight}" class="c-container">
  <div class="c-container__main">
    <ng-content></ng-content>
  </div>
</div>